import React from "react";
import DownloadFormPage from "../components/downloads/DownloadFormPage";

const DownloadCreate = () => <DownloadFormPage mode="create" />;

export default DownloadCreate;
